import { Pipe, PipeTransform } from '@angular/core';
import { omit, sum, values } from 'lodash';

@Pipe({
    name: 'total',
    standalone: false
})
export class DynamicFormCardTotalPipe implements PipeTransform {
  transform(item: Record<string, number>, _omit: string[] = []): number {
    return sum(values(omit(item, _omit)));
  }
}
